export default "__VITE_ASSET__DnCwAYLF__"